import script from "./GalleryEstimation.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryEstimation.view.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryEstimation.view.vue?vue&type=style&index=0&id=3c9951c6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9951c6"]])

export default __exports__